import React, { Component } from "react"
import "./style.scss"

import Menu from "./menu"
import { Link } from "react-router-dom"
import { isMobileApp } from "@/utils/MobileAppUserAgentChecker"

class Header extends Component {
    handelOpenZendesk=(e)=>{
        e.preventDefault();
        // window.open('https://video09.zendesk.com/hc/ko', isMobileApp() ? '_self' : '_blank')
    }
    handleOpenChanelIO=(e)=>{
        e.preventDefault();
        window.ChannelIO('show')
    }
    IsRenderGNBMenu=()=>{
        const pathname=window.location.pathname
        if(pathname==="/" || pathname==="/order/lookup"|| pathname==="/payment/completed") return true;
        return false;
    }
    render() {
        return (
            <header className={"header_container video09_header"} >
                <section className="header_top_section">
                    <div className="layout_empty_box" />
                    <Link to="/">
                        <img src="https://front.videomonster.com/images-u6yd72dy/mobile/video09/logo.webp" alt="logo" />
                    </Link>
                    <div className="burgerMenu-icon">
                        <Menu {...this.props} />
                    </div>
                </section>
                {this.IsRenderGNBMenu() &&
                    <section className="header_bottom_section">
                        <ul>
                            <li>
                                <Link to="/order">주문하기</Link>
                            </li>
                            <li>
                                <Link to="" onClick={this.handelOpenZendesk}>FAQ</Link>
                            </li>
                            <li>
                                <Link to="" onClick={this.handleOpenChanelIO}>세금계산서 발행</Link>
                            </li>
                            <li>
                                <Link to="/order/lookup">주문조회</Link>
                            </li>
                        </ul>
                </section>}
            </header >
        )
    }
}


export default Header